<div class="flex flex-row items-center gap-2 ml-6">
    @for (shortcutItem of shortcutItems; track shortcutItem.url) {
        @if (checkClearance(shortcutItem)) {
            <a
                [matTooltip]="shortcutItem.tooltip"
                [target]="shortcutItem.title"
                [href]="getUrl(shortcutItem)">

                <img [src]="shortcutItem.logo" class="w-6 h-6 filter transform opacity-50 grayscale-50 hover:opacity-100 hover:grayscale-0">

            </a>
        }
    }
</div>
